export const Lastseen = {
    selectors: {
        lastseenSelector: document.querySelector('.js-lastseen')
    },

    init: function() {
        var self = this;
        self.loadEvent(self.selectors.lastseenSelector);
    },

    loadEvent: function (_selector) {
        var self = this;
        let name = 'skls-v2';
        if (_selector) {
            let cookie = self.getCookie(name);
            let id = _selector.dataset.id;
            let items = [];
            if (cookie) {
                let items = cookie.split('%3B');
                while (items.length >= 3) {
                    items.shift();
                }

                if (items.indexOf(id + "") === -1) {
                    items.push(id + "");
                    self.createCookie(name, items.join('%3B'), 7);
                }
            } else {
                items.push(id + "");
                self.createCookie(name, id + "", 7);
            }
        }
    },
    getCookie: function (name) {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        if (parts.length === 2) {
            return parts.pop().split(";").shift();
        }
    },
    createCookie: function (name, content, days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        let expires = "; expires=" + date.toUTCString();
        document.cookie = name + "=" + content  + expires + "; path=/";
    }
};

Lastseen.init();